export const inputCls = "w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none transition-[border-color,box-shadow] focus:border-primary focus:ring-2 focus:ring-primary/20";
export const btnPrimary = "inline-flex items-center justify-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5 disabled:opacity-50";
export const btnGhost = "inline-flex items-center justify-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-xs font-semibold transition-colors hover:bg-accent disabled:opacity-50";
export const LEVELS = ["N5", "N4", "N3", "N2"];
export const AREAS = ["bunpo", "partikel", "kanji", "dokkai", "goi", "hyougen", "kaigo", "nogyo"];

export function F({ label, children, className = "" }) {
  return <label className={`block ${className}`}><span className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-muted-foreground">{label}</span>{children}</label>;
}

export function Sel({ value, onChange, options, testid }) {
  return (
    <select data-testid={testid} value={value} onChange={(e) => onChange(e.target.value)} className={inputCls}>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}
